<template>
    <div>
        <div :style="{color: 'green'}">AUTOPLAY:</div>
        <v-treeview :items="itemsTree">
            <template v-slot:label="{ item }">
                <div>
                    {{item.name}} : <strong> {{ item.value }}</strong> <br/>
                </div>
            </template>
        </v-treeview>
    </div>
</template>

<script>
    import SMPNum from "@/SMPNum";

export default {
    name: "GroupAutoplayTTK",
    props: ['autoPlayPayload', 'pService'],
    watch: {
        autoPlayPayload(newVal, oldVal){
            if (oldVal) {
                // optional: clean up or nullify old references
                oldVal = null;
            }
        }
    },
    methods: {
        getTTKB(){
            return {
                id: 1,
                name: this.getTTKTitle,
                value: this.timeToKillBoss,
                children: [{
                    id: 2,
                    name: 'BossLv',
                    value: this.gameLevel,
                }, {
                    id: 3,
                    name: 'HeroLvKillBoss',
                    value: this.bestHeroLevel,
                    children:[{
                            id: 4,
                            name: 'HeroLvStart',
                            value: this.bestHeroLevelStart,
                        },{
                            id: 5,
                            name: 'HeroLvCanUp',
                            value: this.possibleHeroLevel,
                        }
                    ],
                }, ],
            }
        },
    },
    computed: {
        itemsTree(){
            const items = [];
            items.push(this.getTTKB());
            return items;
        },

        getTTKTitle(){
            const {gameLevel} = this.autoPlayPayload;
            if(this.pService.isZoneBoss(gameLevel)){
                return 'TTKZB';
            }
            return 'TTKNB';
        },
        timeToKillBoss() {
            const {dataAutomateGameState} = this.autoPlayPayload;
            if(dataAutomateGameState){
                return SMPNum.ToReadableTimeValue(new SMPNum(dataAutomateGameState.timeToKillBoss));
            } else {
                return 'NaN';
            }
        },
        gameLevel(){
            const {dataAutomateGameState} = this.autoPlayPayload;
            if(dataAutomateGameState){
                return dataAutomateGameState.stage;
            } else {
                return 'NaN';
            }
        },
        bestHeroLevelStart(){
            const {dataAutomateGameState} = this.autoPlayPayload;
            if(dataAutomateGameState){
                return dataAutomateGameState.lvBestHeroStart;
            } else {
                return 'NaN';
            }
        },
        bestHeroLevel(){
            const {dataAutomateGameState} = this.autoPlayPayload;
            if(dataAutomateGameState){
                let lvW = dataAutomateGameState.levelHeroWinBoss;
                let lvAdd = lvW - dataAutomateGameState.lvBestHeroStart
                return `${lvW} (+${lvAdd})`;
            } else {
                return 'NaN';
            }
        },
        possibleHeroLevel(){
            const {dataAutomateGameState} = this.autoPlayPayload;
            if(dataAutomateGameState){
                /*
                currentLevel = heroData.CurrentLevel;
                lv = SMPHeroLevelConfiguration.GetMaxLevelOnBaseCost(currentLevel, remainingMoney);
                var lvAboveBoss = currentLevel + lv - levelStage;
                GetGameStateModel.lvHeroRemainCanBuy = lvAboveBoss;
                 */
                let lvABV = dataAutomateGameState.lvHeroRemainCanBuy;
                let lvAdd = 0;
                let lvWinB = dataAutomateGameState.levelHeroWinBoss;
                let lvP = lvWinB;
                if(lvABV > 0){
                    lvAdd = lvABV + dataAutomateGameState.stage - lvWinB;
                    lvP = dataAutomateGameState.lvBestHeroStart+lvAdd;
                }
                lvAdd = lvP - dataAutomateGameState.lvBestHeroStart;
                return `${lvP} (+${lvAdd})`;
            } else {
                return 'NaN';
            }
        },
    },
}
</script>

<style scoped>
    >>> .v-treeview-node__root {
        min-height: 30px;
    }
</style>